document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.custom-menu');
    const sections = document.querySelectorAll('.content-section');

    function highlightMenu() {
        let currentSection = '';

        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            if (pageYOffset >= sectionTop - 60) {
                currentSection = section.getAttribute('id');
            }
        });

        menuItems.forEach(item => {
            item.classList.remove('active');
            if (item.getAttribute('href') === `#${currentSection}`) {
                item.classList.add('active');
            }
        });
    }

    window.addEventListener('scroll', highlightMenu);
    window.addEventListener('load', highlightMenu);  // Ensure correct highlighting on page load
});

